var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"drawer-content-wrapper",style:({bottom: _vm.bottom,background:_vm.bgc})},[_c('div',{staticClass:"drawer-content",style:(_vm.contentStyle)},[_vm._t("body")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }